module.exports = __webpack_public_path__ + "static/media/Next.41c0d9a6.svg";